module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-hearts.6dbc6dd3.png";